export const knownFeatures = {
  dashboardSickUnit: 'DASHBOARD_SICK_UNIT',
  dashboardUnitOverview: 'DASHBOARD_UNIT_OVERVIEW',
  dashboardFactsAndFigures: 'DASHBOARD_FACTS_AND_FIGURES',
  dashboardStatisticMaxUptimeScore: 'STATISTICS_MAX_UPTIME_SCORE_DASHBOARD',
  dashboardStatisticElevatorNumberOfTrips: 'DASHBOARD_ELEVATOR_STATISTIC_NUMBER_OF_TRIPS',
  dashboardStatisticElevatorDoorMovements: 'DASHBOARD_ELEVATOR_STATISTIC_DOOR_MOVEMENTS',
  dashboardStatisticElevatorTripDuration: 'DASHBOARD_ELEVATOR_STATISTIC_TRIP_DURATION',
  dashboardServiceRecordHeatmap: 'DASHBOARD_SERVICE_RECORD_HEATMAP',
  dashboardResponseTimeTrafficLight: 'DASHBOARD_RESPONSE_TIME_TRAFFIC_LIGHT',
  dashboardMaxIntegration: 'DASHBOARD_MAX_INTEGRATION',
  dashboardStatisticTripDistance: 'DASHBOARD_TRIP_DISTANCE',
  dashboardAssetList: 'DASHBOARD_ASSET_LIST',
  dashboardLegacyAvailability: 'DASHBOARD_LEGACY_AVAILABILITY',
  dashboardLegacyResponseTime: 'DASHBOARD_LEGACY_RESPONSE_TIME',
  dashboardCallbackDayCounter: 'DASHBOARD_CALLBACK_DAY_COUNTER',
  dashboardStatisticComparison: 'DASHBOARD_STATISTIC_COMPARISON',
  dashboardStatisticEscalatorMaxUptimeScore: 'DASHBOARD_STATISTIC_ESCALATOR_MAX_UPTIME_SCORE',
  dashboardStatisticEscalatorPeopleCounter: 'DASHBOARD_STATISTIC_ESCALATOR_PEOPLE_COUNTER',
  dashboardServiceTicketsTracker: 'DASHBOARD_SERVICE_RECORDS_TRACKER',
  dashboardBreakdownSummary: 'DASHBOARD_BREAKDOWN_SUMMARY',

  dashboardStatisticViewAvailability: 'DASHBOARD_STATISTIC_VIEW_AVAILABILITY',
  dashboardStatisticViewResponseTime: 'DASHBOARD_STATISTIC_VIEW_RESPONSE_TIME',
  dashboardStatisticFilterViewAvailability: 'DASHBOARD_STATISTIC_FILTER_VIEW_AVAILABILITY',
  dashboardStatisticFilterViewResponseTime: 'DASHBOARD_STATISTIC_FILTER_VIEW_RESPONSE_TIME',
  dashboardFilterMaxIntegration: 'DASHBOARD_FILTER_MAX_INTEGRATION',
  statisticViewAvailability: 'STATISTIC_VIEW_AVAILABILITY',
  statisticViewResponseTime: 'STATISTIC_VIEW_RESPONSE_TIME',
  dashboardAverageResponseTime: 'AVERAGE_RESPONSE_TIME',

  portfolioRealtimeStatus: 'PORTFOLIO_REALTIME_STATUS',
  portfolioDetailedRealtimeStatus: 'PORTFOLIO_REALTIME_STATUS_DETAIL',
  portfolioExcelExport: 'PORTFOLIO_EXCEL_EXPORT',

  statisticElevatorTraveledDistance: 'STATISTIC_ELEVATOR_TRAVELED_DISTANCE',
  statisticElevatorTraveledTime: 'STATISTIC_ELEVATOR_TRAVELED_TIME',
  statisticElevatorTripCount: 'STATISTIC_ELEVATOR_TRIP_COUNT',
  statisticElevatorCallDirections: 'STATISTIC_ELEVATOR_CALL_DIRECTIONS',
  statisticElevatorCallWaitTime: 'STATISTIC_ELEVATOR_CALL_WAIT_TIME',
  statisticElevatorDoorMovements: 'STATISTIC_ELEVATOR_DOOR_MOVEMENTS',
  statisticMaxUptimeScore: 'STATISTICS_MAX_UPTIME_SCORE',
  statisticEscalatorStatusDuration: 'STATISTIC_ESCALATOR_STATUS_DURATION',
  statisticEscalatorStatusCount: 'STATISTIC_ESCALATOR_STATUS_COUNT',
  statisticEscalatorPowerConsumption: 'STATISTIC_ESCALATOR_POWER_CONSUMPTION',
  statisticEscalatorEnergyConsumption: 'STATISTIC_ESCALATOR_ENERGY_CONSUMPTION',
  statisticEscalatorMaxUptimeScore: 'STATISTIC_ESCALATOR_MAX_UPTIME_SCORE',
  statisticEscalatorPeopleCounter: 'STATISTIC_ESCALATOR_PEOPLE_COUNTER',

  statisticLegacyCompliance: 'STATISTIC_LEGACY_COMPLIANCE_LEVEL',
  statisticLegacyDowntimeFaults: 'STATISTIC_LEGACY_DOWNTIME_FAULTS',
  statisticLegacyBreakdowns: 'STATISTIC_LEGACY_BREAKDOWNS',
  statisticLegacyRescues: 'STATISTIC_LEGACY_RESCUES',
  statisticLegacyResponseTime: 'STATISTIC_LEGACY_RESPONSE_TIME',
  statisticLegacyTotalDowntime: 'STATISTIC_LEGACY_TOTAL_DOWNTIME',
  statisticLegacyOperationalCounter: 'STATISTIC_LEGACY_OPERATIONAL_COUNTER',
  statisticLegacyDaysWithoutCallback: 'STATISTIC_LEGACY_DAYS_WITHOUT_CALLBACK',

  requestsExcelExport: 'REQUESTS_EXCEL_EXPORT',

  serviceRecordsExcelExport: 'SERVICE_RECORDS_EXCEL_EXPORT',

  inspectionsOverview: 'INSPECTIONS_OVERVIEW',
  inspectionsExcelExport: 'INSPECTIONS_EXCEL_EXPORT',
  inspectionsDocumentDownload: 'INSPECTIONS_DOCUMENT_DOWNLOAD',

  invoiceOverview: 'INVOICES_OVERVIEW',
  invoiceWidget: 'INVOICES_WIDGET',
  invoiceExcelExport: 'INVOICES_EXCEL_EXPORT',
  invoiceBundleDownload: 'INVOICES_BUNDLE_DOWNLOAD',
  invoiceShowPaymentStatus: 'INVOICES_SHOW_PAYMENT_STATUS',
  invoiceDownload: 'INVOICES_DOWNLOAD',
  invoiceStatistics: 'INVOICES_STATISTICS',

  pricingTierInformation: 'PRICING_TIER_INFORMATION',
  freeDashboard: 'FREE_DASHBOARD',

  equipmentExtendedTechnicalDetails: 'EQUIPMENT_EXTENDED_TECHNICAL_DETAILS',
  otherEquipmentExtendedTechnicalDetails: 'OTHER_EQUIPMENT_EXTENDED_TECHNICAL_DETAILS',

  quotesExcelExport: 'QUOTES_EXCEL_EXPORT',
  quotesDocumentDownload: 'QUOTES_DOCUMENT_DOWNLOAD',
  quotesBundleDownload: 'QUOTES_BUNDLE_DOWNLOAD',

  globalSearch: 'GLOBAL_SEARCH',

  realtimeStatusUpdates: 'REALTIME_STATUS_UPDATES',

  rtsAlertNotification: 'NOTIFICATION_RTS_ALERT',
  rtsAlertNotificationByMail: 'NOTIFICATION_RTS_ALERT_BY_MAIL',
  rtsAlertNotificationPushNotification: 'NOTIFICATION_RTS_ALERT_BY_PUSH_NOTIFICATION',

  serviceTicketNotificationAssignAlert: 'NOTIFICATIONS_STATUS_OF_TICKET_ASSIGN_ALERT',
  serviceTicketNotificationAssignAlertByMail: 'NOTIFICATIONS_STATUS_OF_TICKET_ASSIGN_ALERT_BY_MAIL',
  serviceTicketNotificationOnSite: 'NOTIFICATIONS_STATUS_OF_TICKET_ON_SITE',
  serviceTicketNotificationOnSiteByMail: 'NOTIFICATIONS_STATUS_OF_TICKET_ON_SITE_BY_MAIL',
  serviceTicketNotificationOnSiteByPushNotification:
    'NOTIFICATIONS_STATUS_OF_TICKET_ON_SITE_BY_PUSH_NOTIFICATION',
  serviceTicketNotificationDebriefReduced: 'NOTIFICATIONS_STATUS_OF_TICKET_DEBRIEF_REDUCED',
  serviceTicketNotificationDebriefReducedByMail:
    'NOTIFICATIONS_STATUS_OF_TICKET_DEBRIEF_REDUCED_BY_MAIL',
  serviceTicketNotificationNotifyEvent: 'NOTIFICATIONS_STATUS_OF_TICKET_NOTIFY_EVENT',
  serviceTicketNotificationNotifyEventByMail: 'NOTIFICATIONS_STATUS_OF_TICKET_NOTIFY_EVENT_BY_MAIL',

  unitShutdownNotificationAlert: 'NOTIFICATION_UNIT_SHUTDOWN_ALERT',
  unitShutdownNotificationAlertByMail: 'NOTIFICATION_UNIT_SHUTDOWN_ALERT_BY_MAIL',
  unitShutdownNotificationAlertPushNotification:
    'NOTIFICATION_UNIT_SHUTDOWN_ALERT_BY_PUSH_NOTIFICATION',

  sendMonthlyReport: 'SEND_MONTHLY_REPORT',
  preventiveMaintenanceSummary: 'PREVENTIVE_MAINTENANCE_SUMMARY',
  serviceTicketNotificationAssignAlertByPushNotification:
    'NOTIFICATIONS_STATUS_OF_TICKET_ASSIGN_ALERT_BY_PUSH_NOTIFICATION',
  serviceTicketNotificationDebriefReducedByPushNotification:
    'NOTIFICATIONS_STATUS_OF_TICKET_DEBRIEF_REDUCED_BY_PUSH_NOTIFICATION',
  serviceTicketNotificationNotifyEventByPushNotification:
    'NOTIFICATIONS_STATUS_OF_TICKET_NOTIFY_EVENT_BY_PUSH_NOTIFICATION',

  portfolio: 'PORTFOLIO',
  communicationUploadSharedFile: 'COMMUNICATION_UPLOAD_SHARED_FILE',
  qrCodeGeneration: 'QR_CODE_GENERATION',
  welcomeMessage: 'WELCOME_MESSAGE',
  video: 'VIDEO_SET',

  communicationsQuotes: 'COMMUNICATIONS_QUOTES',
  communicationsRequests: 'COMMUNICATIONS_REQUESTS',
  dashboard: 'DASHBOARD',
  newDashboard: 'DASHBOARD_2.0',
  modularDashboard: 'DASHBOARD_MODULAR',
  communications_overview_unified: 'COMMUNICATIONS_OVERVIEW_UNIFIED',
  communications_creation_form_unified: 'COMMUNICATIONS_CREATION_FORM_UNIFIED',
  contacts: 'CONTACTS',
  help: 'HELP',
  reportArchive: 'REPORT_ARCHIVE',

  assetAnalysis: 'ASSET_ANALYSIS',
  ticketReports: 'TICKET_REPORTS',
  userDefinedReports: 'USER_DEFINED_REPORTS',
  brazilianAvailability: 'STATISTIC_LEGACY_AVAILABILITY_BR',

  availabilityReports: 'AVAILABILITY_REPORTS',
  availabilityReportsExcelExport: 'AVAILABILITY_REPORTS_EXCEL_EXPORT',

  contactUs: 'CONTACT_US',
  portfolioOperationModes: 'PORTFOLIO_OPERATIONAL_MODES',

  serviceModeNotification: 'NOTIFICATIONS_UNIT_SERVICE_MODE_ALERT',
  serviceModeNotificationByEmail: 'NOTIFICATIONS_UNIT_SERVICE_MODE_ALERT_BY_EMAIL',
  serviceModeNotificationByPushNotification:
    'NOTIFICATIONS_UNIT_SERVICE_MODE_ALERT_BY_PUSH_NOTIFICATION',
};
